'use strict';

function Toggler(container, body, options) {
    this.$container = $(container);
    this.$body = this.$container.find(body);

    if (!$.isEmptyObject(options)) {
        this.toggler = new Foundation.Toggler(this.$container, options);
    } else {
        this.toggler = new Foundation.Toggler(this.$container);
    }

    this.events = {
        onOpen: function (callback) {
            this.$container.off('on.zf.toggler').on('on.zf.toggler', function () {
                if (typeof callback === 'function') {
                    callback();
                }
                this.$container.off('on.zf.toggler');
            });
        },

        onClose: function (callback) {
            this.$container.off('off.zf.toggler').on('off.zf.toggler', function () {
                if (typeof callback === 'function') {
                    callback();
                }
                this.$container.off('off.zf.toggler');
            });
        }
    };
}

Toggler.prototype.renderContent = function (content, callback) {
    this.$body.html(content);

    if (typeof callback === 'function') {
        callback();
    }
};

export default {
    create: function (container, body, options) {
        return new Toggler(container, body, options);
    }
}